export default __webpack_public_path__ + "static/media/icons8-git.6e5eda8d.png";